import { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { generateSpiralPositions } from './utils/spiralGenerator';
import * as THREE from 'three';

export function Galaxy() {
  const groupRef = useRef<THREE.Group>(null);
  
  const { positions, colors } = useMemo(() => {
    const particleCount = 12000; // Increased particle count for more detail
    const positions = new Float32Array(particleCount * 3);
    const colors = new Float32Array(particleCount * 3);
    
    generateSpiralPositions(positions, colors, particleCount);
    
    return { positions, colors };
  }, []);

  useFrame((_state, delta) => {
    if (groupRef.current) {
      groupRef.current.rotation.y += delta * 0.025; // Slightly slower rotation
    }
  });

  return (
    <group ref={groupRef}>
      <points>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            args={[positions, 3]}
            count={positions.length / 3}
            array={positions}
            itemSize={3}
          />
          <bufferAttribute
            attach="attributes-color"
            args={[colors, 3]}
            count={colors.length / 3}
            array={colors}
            itemSize={3}
          />
        </bufferGeometry>
        <pointsMaterial
          size={0.035} // Slightly smaller particles
          vertexColors
          transparent
          opacity={0.7} // More transparency
          sizeAttenuation
          blending={THREE.AdditiveBlending}
          depthWrite={false} // Better particle blending
        />
      </points>
    </group>
  );
}